import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Icon } from "../Icon/index.js";
const AbsenceTypeIcon = (t0)=>{
    const $ = c(3);
    const { variant, color } = t0;
    let iconName;
    switch(variant){
        case "vacation":
            iconName = "vkhrtek_vacation";
            break;
        case "maternity_leave":
            iconName = "vkhrtek_maternity_leave";
            break;
        case "student_leave":
            iconName = "education_outline";
            break;
        case "business_trip":
            iconName = "plane_outline";
            break;
        case "sick_leave":
            iconName = "vkhrtek_medical";
            break;
        default:
            iconName = "calendar_outline";
    }
    let t1;
    if ($[0] !== color || $[1] !== iconName) {
        t1 = /*#__PURE__*/ jsx(Icon, {
            name: iconName,
            size: "14",
            color: color
        });
        $[0] = color;
        $[1] = iconName;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
export { AbsenceTypeIcon };
